export const DENSITY_PADDING = {
  compact: 'small',
  regular: 'large',
  spacious: 'xxlarge',
} as const;
